import "../Css/home.css"

export default function Skilldot() {
  return (
    <div className='skillDot'>
    </div>
  )
}
